module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    ref: "dropdown",
    class: _vm.className,
    style: (_vm.style),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e9f5d5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Component.vue
// module id = 7
// module chunks = 0